import classnames from 'classnames';
import PropTypes from 'prop-types';
import React, { useCallback } from 'react';

import { Icon } from '@/design-system/atoms/Icons/Icon';

import styles from './AudioListItem.module.scss';

const AudioVolume = (props) => {
    const { isMuted, volume, onVolumeChange, onToggleMuted } = props;

    /**
     *
     * input handler
     * update the background color style based on its value
     *
     */
    const handleOnInput = useCallback((event) => {
        event.target.style.background = `linear-gradient(to right,
            var(--color-primary-slate) 0%,
            var(--color-primary-slate) ${event.target.value}%,
            var(--color-opacity-grey-4-10) ${event.target.value}%,
            var(--color-opacity-grey-4-10) 100%)`;
    }, []);

    return (
        <div className={classnames(styles[`audio__volume`])}>
            <div className={classnames(styles[`audio__volume__mute`])}>
                <button onClick={onToggleMuted}>
                    <Icon name={isMuted ? 'volume' : 'volume2'} size={25} />
                </button>
            </div>
            <div className={classnames(styles[`audio__volume__controller`])}>
                <input
                    type="range"
                    min="0"
                    max="100"
                    value={volume}
                    onInput={handleOnInput}
                    onChange={onVolumeChange}
                />
            </div>
        </div>
    );
};

AudioVolume.propTypes = {
    /**
     * Audio muted value
     */
    isMuted: PropTypes.bool,
    /**
     * Audio volume value
     */
    volume: PropTypes.string,
    /**
     * Audio volume callback
     */
    onVolumeChange: PropTypes.func,
    /**
     * Audio muted callback
     */
    onToggleMuted: PropTypes.func,
};

export default AudioVolume;
